import { DigitalWalletStatus } from "@/models/enums";
import { Grid, InputLabel, MenuItem, Select, SelectChangeEvent, IconButton } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import "./digital.wallet.status.select.css";
import ClearIcon from "@/assets/icons/clear-icon.svg";

interface IDigitalWalletStatusSelect {
    value?: string | null;
    title: string;
    width?: string;
    updateStatus: (arg?: string | null) => void;
}

const DigitalWalletStatusSelect: FC<IDigitalWalletStatusSelect> = (props: IDigitalWalletStatusSelect) => {
    const { t } = useTranslation();
    const selectOptions = [
        { id: null, text: t("general.All") },
        { id: "Active", text: t("general.Active") },
        { id: "NotActive", text: t("general.Inactive") },
        { id: "NotEstablished", text: t("general.NotEstablished") },
    ];
    return (
        <Grid className="select-digital-wallet-status-grid">
            <InputLabel id="select-digital-wallet-status-label">{props.title}</InputLabel>
            <Select
                id="digital-wallet-select-status"
                labelId="select-digital-wallet-status-label"
                className="digital-wallet-select-status"
                label={props.title}
                sx={{ width: props.width ?? "100%" }}
                onChange={(e: SelectChangeEvent) => {
                    if (e.target.value) {
                        const option = selectOptions.find(({ text }) => text === e.target.value);
                        if (option) props.updateStatus(option.id);
                    }
                }}
                value={selectOptions.find(({ id }) => id === props.value)?.text}
                endAdornment={
                    <IconButton
                        className="select-clear-icon"
                        sx={{
                            visibility: props.value ? "visible" : "hidden",
                        }}
                        onClick={() => props.updateStatus(null)}
                    >
                        <img src={ClearIcon} alt="Clear icon" />
                    </IconButton>
                }
            >
                {selectOptions.map(({ text }) => (
                    <MenuItem key={text} value={text}>
                        {text}
                    </MenuItem>
                ))}
            </Select>
        </Grid>
    );
};

export default DigitalWalletStatusSelect;
